/**
 * Created by wwei on 2018-11-09.
 */
import React, { Component } from "react";
import { translate } from "react-i18next";
import { NavLink } from "react-router-dom";
import { URL } from "../../../common/Constants.js";
import SvgIcon from "../../../common/components/SvgIcon";

class A4BSideBar extends Component {
  render() {
    const { t, showMenuWords, width } = this.props;
    return (
      <div>
        <nav className="ts-sidebar" style={{ width: width }}>
          <ul className="ts-sidebar-menu">
            {/*<li title={t("A4B.SERVICE_CONFIG")}>
                            <NavLink
                                to={URL.A4B.SERVICE_CONFIG}
                                activeClassName="active"
                                id="service_config_menu"
                            >
                                <table>
                                    <tbody>
                                    <tr>
                                        <td><SvgIcon name="settings"/></td>
                                        <td>{showMenuWords ? t("A4B.SERVICE_CONFIG") : ""}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </NavLink>
                        </li>*/}
            <li title={t("A4B.AMAZON_ACCOUNT")}>
              <NavLink
                to={URL.A4B.AMAZON_ACCOUNT}
                activeClassName="active"
                id="amazon_account_menu"
              >
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <SvgIcon name="person" />
                      </td>
                      <td>{showMenuWords ? t("A4B.AMAZON_ACCOUNT") : ""}</td>
                    </tr>
                  </tbody>
                </table>
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default translate()(A4BSideBar);



// WEBPACK FOOTER //
// ./src/tenantportal/a4b/main/A4BSideBar.js